export default __webpack_public_path__ + "static/sean-becker-logo-f3ad88607bc8ba61abce12140bc28ceb.jpg";